const BRT_TIMEZONE = 'America/Sao_Paulo';

const PAGE_ERRORS = {
    notFound: 'not_found',
    alreadyLinked: 'already_linked',
};

const BADGE_COLORS = {
    express: { color: '#E11D48', bg: '#FFE4E6' },
    urgent:  { color: '#D97706', bg: '#FEF3C7' },
    expressAccent: '#F9C31A',
};

export const expressDeliveryConstants = {
    BRT_TIMEZONE,
    PAGE_ERRORS,
    BADGE_COLORS,
};
